/*
 * @Author: bianbinbin
 * @Date: 2023-12-15 16:30:47
 * @LastEditors: bianbinbin
 * @LastEditTime: 2024-01-09 09:14:25
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/fault-retain.js
 */
const faultRetainDetail = r =>
  require.ensure([], () => r(require('@/views/faultRetain/faultRetainDetail.vue'), 'faultRetainDetail'))
const outFaultRetainDetail = r =>
  require.ensure([], () => r(require('@/views/faultRetain/outFaultRetainDetail.vue'), 'outFaultRetainDetail'))
const faultRetain = r => require.ensure([], () => r(require('@/views/faultRetain/faultRetain.vue'), 'faultRetain'))

const router = [
  {
    path: '/faultRetain',
    name: 'faultRetain',
    meta: {
      title: '故障保留'
    },
    component: faultRetain
  },
  {
    path: '/faultRetainDetail',
    name: 'faultRetainDetail',
    meta: {
      title: '故障保留单详情'
    },
    component: faultRetainDetail
  },
  {
    path: '/outFaultRetainDetail',
    name: 'outFaultRetainDetail',
    meta: {
      title: '故障保留单详情'
    },
    component: outFaultRetainDetail
  }
]

export default router
